export default "__VITE_ASSET__Hxwmoma6__"